/*
 * 基于axios的Http库
 * baseUrl: 根API地址
 * http: 封装的请求对象
 * 用法：import {http} from 'http'
 * */
import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui';
import {Ticket} from '@/utils';
import i18n from '@/assets/i18n'
import md5 from '@/utils/md5'
//import router from '@/router';

const appConfig = require('@/config');

export const oaURL = 'http://oa.nuctech.com/pages/home.aspx';

// axios 配置
axios.defaults.timeout = 30000;
axios.defaults.baseURL = appConfig.baseUrl;

// 请求拦截
axios.interceptors.request.use((config) => {
    const ticket = Ticket.get();

    // 有票，设Authorization
    if (ticket) {
        let token = ticket.access_token;
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;

}, (error) => {
    Message({message: `error 请求被拦截: ${error}`, duration: 2000});
    return Promise.reject(error);
});

// 返回状态判断
axios.interceptors.response.use(response => {
    let message = response.data.error || response.data.message;

    if (response.data.timestamp) { // !记录并消除后台系统与用户本机的时间差异
        md5.updateSystemDeltaTime(response.data.timestamp)
    }

    if (!response.data.result) {
        // 如果配置noShowError为true，则不显示错误提示
        if (!response.config.noShowError) {
            Message({message, duration: 2000});
        }
        return Promise.reject(response);
    }

    // 对响应数据做点什么
    return response.data;

}, (error) => {
    let errMsg = i18n.t('http.error'); //网络异常

    if (error.response) {
        if (error.response.status === 401) {
            Ticket.backToLogin()
            return;
        }
        if (error.response.status === 403) {
            errMsg = i18n.t('http.forbidden');  //禁止访问：Forbidden
        }
        if (error.response.status === 500) {
            errMsg = i18n.t('http.serverError');  //服务器异常
        }
    }

    if (error.code === 'ECONNABORTED') {
        errMsg = i18n.t('http.timeout');  //请求超时
    }

    Message({message: errMsg, duration: 2000});

    return Promise.reject(error);
});


export const http =  {
    /**
     *
     * @param url
     * @param data（可选）
     * @returns {Promise}
     */
    get(url, data = {}, options = {}) {
        let _data = Object.assign({}, data, {culture: i18n.locale, 'ui-culture': i18n.locale});

        let config = {
            params: _data,
            headers: {
                DKEY: md5.genMd5(),
            },
            'paramsSerializer': function (params) {
                return qs.stringify(params, {indices: false})
            },
            ...options
        };

        return axios.get(url, config)
    },

    /**
     *
     * @param url
     * @param data
     * @param options（可选）
     * @returns {Promise}
     */
    post(url, data, options = {}) {
        if (options.contentType === 'form') {
            data = qs.stringify(data);
        } else if (options.contentType !== 'file') {
            data = JSON.stringify(data);
        }

        let config = {
            headers: {
                DKEY: md5.genMd5(),
                'Content-Type': (() => {
                    if (options.contentType === 'form') {
                        return 'application/x-www-form-urlencoded;charset=utf-8'
                    }
                    if (options.contentType === 'file') {
                        return 'multipart/form-data'
                    }
                    return 'application/json'
                })()
            },
            params: {culture: i18n.locale, 'ui-culture': i18n.locale},
            ...options
        };

        return axios.post(url, data, config)
    },

    /**
     *
     * @param url
     * @param data
     * @param options（可选）
     * @returns {Promise}
     */
    put(url, data = {}, options = {}) {
        if (options.contentType === 'form') {
            data = qs.stringify(data);
        } else {
            data = JSON.stringify(data);
        }

        let config = {
            headers: {
                DKEY: md5.genMd5(),
                'Content-Type': options.contentType === 'form' ? 'application/x-www-form-urlencoded;charset=utf-8' :
                    'application/json'
            },
            params: {culture: i18n.locale, 'ui-culture': i18n.locale},
        };

        return axios.put(url, data, config)
    },

    /**
     *
     * @param url
     * @returns {Promise}
     */
    delete(url, data = {}, options = {}) {
        if (options.contentType === 'json') {
            data = JSON.stringify(data);
        } else {
            data = qs.stringify(data);
        }

        let config = {
            data: data,
            headers: {
                DKEY: md5.genMd5(),
                'Content-Type': options.contentType == 'json' ? 'application/json':
                    'application/x-www-form-urlencoded;charset=utf-8'
            },
            params: {culture: i18n.locale, 'ui-culture': i18n.locale},
            ...options
        };

        return axios.delete(url, config)

    }
}
